"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from "react";
import Api from "../api/api";
import { Flash } from "../components/flash";
import WaitingSpinner from "../components/waiting_spinner";
function RemoveFromWaiting(props) {
  const [removingFromWaiting, setRemovingFromWaiting] = useState(false);
  const onComplete = useRef(props.onComplete);
  useLayoutEffect(() => {
    onComplete.current = props.onComplete;
  });
  const removeButton = () => {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: "button--caution remove-from-waiting__button",
        onClick: removeFromWaiting,
        children: "Remove from Waiting"
      }
    );
  };
  const removeFromWaiting = () => {
    setRemovingFromWaiting(true);
    Api.ExceptionedItems.clearActiveItem(props.itemId).then(() => {
      setRemovingFromWaiting(false);
      onComplete.current();
      Flash.success("Item Successfully Removed From Waiting!");
    }).catch(() => {
      setRemovingFromWaiting(false);
    });
  };
  return /* @__PURE__ */ jsx(
    WaitingSpinner,
    {
      "data-component": "RemoveFromWaiting",
      when: removingFromWaiting,
      children: /* @__PURE__ */ jsxs("div", { className: "alert-box  secondary", children: [
        /* @__PURE__ */ jsx("div", { className: "row", children: "It looks like you've sent a message on an invoice that has already been processed or approved. Do you want to remove it from the waiting queue?\xA0" }),
        /* @__PURE__ */ jsxs("div", { className: "row", children: [
          " ",
          removeButton()
        ] })
      ] })
    }
  );
}
export default RemoveFromWaiting;
